import React, { useState } from 'react';
import { IntroStep } from '../components/face-analysis/IntroStep';
import { LeadFormStep, LeadInfo } from '../components/face-analysis/LeadFormStep';
import { CameraStep, CaptureAngle, CapturedFrame } from '../components/face-analysis/CameraStep';
import { QualityCheckStep } from '../components/face-analysis/QualityCheckStep';
import { AnalyzingStep } from '../components/face-analysis/AnalyzingStep';
import { ResultsStep } from '../components/face-analysis/ResultsStep';
export type FaceAnalysisStep = 'intro' | 'leadForm' | 'camera' | 'quality' | 'analyzing' | 'results';
const ANGLE_SEQUENCE: CaptureAngle[] = ['front', 'angle45', 'side'];
export function FaceAnalysisPage() {
  // Start directly on the lead form when the page opens
  const [step, setStep] = useState<FaceAnalysisStep>('leadForm');
  const [captures, setCaptures] = useState<CapturedFrame[]>([]);
  const [currentAngleIndex, setCurrentAngleIndex] = useState(0);
  const [leadInfo, setLeadInfo] = useState<LeadInfo | null>(null);
  const handleStart = () => setStep('leadForm');
  const handleLeadSubmit = (info: LeadInfo) => {
    setLeadInfo(info);
    // Show the analyzing loader indefinitely (never resolves)
    setStep('analyzing');
  };
  const handleCapture = (frame: CapturedFrame) => {
    const next = [...captures, frame];
    setCaptures(next);
    if (currentAngleIndex < ANGLE_SEQUENCE.length - 1) {
      setCurrentAngleIndex(currentAngleIndex + 1);
    } else {
      setStep('quality');
    }
  };
  const handleQualityContinue = () => {
    setStep('analyzing');
    setTimeout(() => setStep('results'), 3500);
  };
  const restartScan = () => {
    setCaptures([]);
    setCurrentAngleIndex(0);
    setStep('camera');
  };
  const frontCapture = captures.find(c => c.angle === 'front');
  return <div className="min-h-screen bg-brand-bg/30 pt-28 pb-20" data-id="element-847">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-848">
        {step === 'intro' && <IntroStep onStart={handleStart} data-id="element-849" />}
        {step === 'leadForm' && <LeadFormStep onSubmit={handleLeadSubmit} onBack={() => setStep('intro')} data-id="element-850" />}
        {step === 'camera' && <CameraStep key={currentAngleIndex} currentAngle={ANGLE_SEQUENCE[currentAngleIndex]} captureIndex={currentAngleIndex + 1} totalCaptures={ANGLE_SEQUENCE.length} previousCaptures={captures} onCapture={handleCapture} data-id="element-851" />}
        {step === 'quality' && <QualityCheckStep captures={captures} onContinue={handleQualityContinue} onRescan={restartScan} data-id="element-852" />}
        {step === 'analyzing' && <AnalyzingStep data-id="element-853" />}
        {step === 'results' && frontCapture && <ResultsStep imageSrc={frontCapture.imageSrc} landmarks={frontCapture.landmarks} onRetake={restartScan} data-id="element-854" />}
      </div>
    </div>;
}